export function logout(token: any) {
    localStorage.clear();
    localStorage.clear();
    window.location.replace("/attendant/logout");
}
